import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { CategoryFromDashboard, ContainerFromDashboard, DashbordRes } from '@classes/dashboard/dashboard';
import { faHistory, faInfoCircle, faPlusSquare, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { DashboardService } from '@services/dashboard/dashboard.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { OpendialogNewContainerComponent } from '../opendialog-new-container/opendialog-new-container.component';

@Component({
  selector: 'app-container-progress',
  templateUrl: './container-progress.component.html',
  styleUrls: ['./container-progress.component.scss']
})
export class ContainerProgressComponent extends SubscriptionBaseComponent implements OnInit {

  faHistory = faHistory;
  faInfoCircle = faInfoCircle;
  faSyncAlt = faSyncAlt;
  faPlusSquare = faPlusSquare;

  progressContainer = 0;
  progressContainerWidt = 0;
  showValue = false;
  dashboardRes: DashbordRes;

  constructor(
    public router: Router,
    private dashboardService: DashboardService,
    private dialog: MatDialog,
  ) {
    super();
    // reload the component on click
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
  }

  ngOnInit(): void {
    this.getContainerDashboard();
  }

  openDialogNewContainer(): void {
    const dialogRef = this.dialog.open(OpendialogNewContainerComponent);

    dialogRef.afterClosed().subscribe(() => {
      this.getContainerDashboard();
    });
  }

  private getContainerDashboard(): void {
    this.dashboardService.getContainerDashboard().subscribe(res => {
      this.dashboardRes = res;
      this.initProgressContainer(res.categories);
    });
  }

  private initProgressContainer(container: CategoryFromDashboard[]): void {
    const progress = document.getElementsByClassName('progress_container') as HTMLCollectionOf<HTMLElement>;

    progress[0].style.color = '#000';
    progress[0].style.width = '0';

    this.progressContainer = (100 / container[0].threshold) * container[0].sum;
    this.progressContainer = Math.round(this.progressContainer * 100) / 100;

    this.progressContainer > 100 ? this.progressContainerWidt = 100 : this.progressContainerWidt = this.progressContainer;
    if (this.progressContainer > 100) {
      progress[0].style.backgroundColor = '#ff0000';
      progress[0].style.color = '#fff';
      progress[0].style.fontWeight = 'bold';
    }
    setTimeout(() => {
      progress[0].style.width = Math.ceil(this.progressContainerWidt).toString() + '%';
    }, 500);
    setTimeout(() => {
      this.showValue = true;
    }, 600);

  }
}
